import { render, staticRenderFns } from "./verify-user.vue?vue&type=template&id=7740e830"
import script from "./verify-user.vue?vue&type=script&lang=ts"
export * from "./verify-user.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports